import { useEffect, useState } from "react";
import "../App.css";
import "./Nav.css";
import { AnimatePresence, motion } from "framer-motion";

export const navItems = [
    {
        title: "About",
        path: "/about",
    },
    {
        title: "Research",
        path: "/research",
    },
    {
        title: "Frames",
        path: "/gallery",
    },
]


function colorPicker(color) {
    color = (color.charAt(0) === '#') ? color.substring(1, 7) : color;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    var uicolors = [r / 255, g / 255, b / 255];
    var c = uicolors.map((col) => {
        if (col <= 0.03928) {
            return col / 12.92;
        }
        return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
    return (L > 0.179) ? "dark" : "light";
}

const Nav = (current, color = "#FFFFFF") => {
    const [dropped, setDrop] = useState(false);
    const barSrc = (colorPicker(color) === "dark") ? "img/bar_dark.svg" : "img/bar_light.svg";
    const [iconSrc, setIcon] = useState(barSrc);

    // This initalState argument in useState is ignored after the initial render.
    useEffect(() => {
        setIcon(barSrc);
    }, [barSrc]);

    function toggleMenu() {
        setIcon(dropped ? barSrc : "img/close.svg");
        setDrop(!dropped);
    }

    const pageVars = {
        initial: {
            scaleY: 0,
        },
        animate: {
            scaleY: 1,
            transition: {
                duration: 0.5,
                ease: [0.12, 0, 0.39, 0],
                staggerChildren: 0.5,
            }
        },
        exit: {
            scaleY: 0,
            transition: {
                delay: 0.5,
                duration: 0.5,
                ease: [0.22, 1, 0.36, 1],
            }
        }
    }

    const menuVars = {
        hidden: {
            transition: {
                staggerChildren: 0.09,
                staggerDirection: -1,
            }
        },
        show: {
            transition: {
                delayChildren: 0.3,
                staggerChildren: 0.09,
                staggerDirection: 1,
            }
        }
    }

    const menuItemVars = {
        hidden: {
            y: "30vh",
            transition: {
                duration: 0.5,
                ease: [0.37, 0, 0.63, 1]
            }
        },
        show: {
            y: 0,
            transition: {
                duration: 0.7,
                ease: [0, 0.55, 0.45, 1]
            }
        }
    }


    return (
        <>
            <nav>
                <div className="side-nav-container">
                    {
                        navItems.map((item) => {
                            return (
                                <div className="button-block" id={current === item.title.toLowerCase() ? "highlight" : "inactive"}>
                                    <a className="nav-button" href={item.path}>
                                        <img className="icon" src={"img/" + item.title.toLowerCase() + ".svg"} alt={item.title} />
                                    </a>
                                </div>
                            )
                        })
                    }
                </div>


                <div className="mobile-nav-bar">
                    <div className="nav-mobile" onClick={toggleMenu}>
                        <img src={iconSrc} alt="navigation bar" className="icon" />
                    </div>
                </div>
            </nav>

            {/* Dropdown page */}
            <AnimatePresence>
                {dropped && (
                    <motion.div className="mobile-nav-page"
                        variants={pageVars}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        style={{ originY: 0 }}>
                        <motion.div className="nav-list"
                            variants={menuVars}
                            initial="hidden"
                            animate="show"
                            exit="hidden">
                            {
                                navItems.map((item) => {
                                    return (
                                        <div className="overflow-hidden">
                                            <motion.div className="nav-item button-block"
                                                variants={menuItemVars}>
                                                <a href={item.path}>{item.title}</a>
                                            </motion.div>
                                        </div>
                                    )
                                })
                            }
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default Nav;
